import clsx from 'clsx';
import React from 'react';

import styles from './Badge.module.scss';

export function Badge({ badge }: { badge: string }) {
  const badgeClass = clsx('text text-bold', styles.badge, styles[badge]);

  return <span className={badgeClass}>{badge}</span>;
}
